import { ConnectedRouter } from '@jauntin/react-ui';
import { SCREEN_SIZE } from '../Actions/actions';
import RouteParser from '../Helpers/RouteParser';

const classNameForPage = (page) => `page-${page}`;
const pageClassNames = Object.values(RouteParser.formParts).map((m) =>
  classNameForPage(m),
);

const BodyClassMiddleware = (store) => (next) => (action) => {
  // Let the action happen first, and then deal with it
  next(action);
  if (action.type === ConnectedRouter.LOCATION_CHANGE) {
    const state = store.getState();
    const routeParser = RouteParser.create(state.router.location.pathname);
    pageClassNames.forEach((element) => {
      document.body.classList.remove(element);
    });
    const currentPage = routeParser.selectedPage();
    document.body.classList.add(classNameForPage(currentPage));
  } else if (action.type === SCREEN_SIZE) {
    const state = store.getState();
    if (state.formPage.summary.mobileDisplay) {
      document.body.classList.add('mobile');
      document.body.classList.remove('desktop');
    } else {
      document.body.classList.add('desktop');
      document.body.classList.remove('mobile');
    }
  }
};

export default BodyClassMiddleware;
